import { instance, errorService, savePreviousData } from '@/services/api'
import { templateAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import {
  calculateAreaBuildingFootprint,
  calculateHeight,
  calculatePerimeter,
  showNotification,
} from '@/services/calculate'
import {
  socketEvents,
  checkFiles,
  formatKeys,
  validateNumber,
  tableName,
} from '@/services/config'
import { updateGridRecord } from '@/services/grid'
import { formatValue } from '@/services/convert'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import InputEditor from '@/components/DynamicComponents/Renderers/inputEditor'
import SelectEditorDynamic from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import exportTemplates from '@/components/DynamicComponents/Templates/Export'
import importTemplates from '@/components/DynamicComponents/Templates/Import'
import bankModal from '@/components/DynamicComponents/Templates/BankModal'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'

export default {
  props: [
    'templateData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'projectModule',
    'viewOnly',
    'collapsed',
    'columnSettings',
  ],
  components: {
    'ag-grid-vue': AgGridVue,
    exportTemplates,
    importTemplates,
    bankModal,
  },
  data() {
    return {
      savePreviousData: savePreviousData,
      tableLoader: false,
      fieldLoader: false,
      fieldName: null,
      dataSourceInterior: [],
      loading: true,
      selected: false,
      formGeneral: {
        id: undefined,
        conditionFactorId: undefined,
        constructionQualityFactorId: undefined,
        softCosts: undefined,
        areaTotalBuilding: undefined,
        numberOfStories: undefined,
        areaBuildingFootprint: undefined,
        perimeterBuildingFootprint: undefined,
        averageStoryHeight: undefined,
        totalSiteArea: undefined,
        numberOfBuilding: 1,
      },
      formTenants: {
        id: undefined,
        tenantApproachId: null,
        tenantApproach: undefined,
        tenantId: undefined,
        tenantBank: undefined,
        tenantBankId: undefined,
        tenantType: undefined,
        tenantTypeId: undefined,
        tenantSF: undefined,
        tenants: [],
      },
      rulesformGeneral: {
        constructionQualityFactorId: [
          {
            required: true,
            message: 'Please select construction quality factor',
            trigger: 'change',
          },
        ],
        conditionFactorId: [
          {
            required: true,
            message: 'Please select condition factor',
            trigger: 'change',
          },
        ],
        softCosts: [
          {
            required: true,
            message: 'Please enter soft costs (%)',
            trigger: 'blur',
          },
        ],
        areaTotalBuilding: [
          {
            required: true,
            message: 'Please enter area of total building',
            trigger: 'blur',
          },
        ],
        numberOfStories: [
          {
            required: true,
            message: 'Please enter number of stories',
            trigger: 'blur',
          },
        ],
        areaBuildingFootprint: [
          {
            required: true,
            message: 'Please enter area building foot print',
            trigger: 'blur',
          },
        ],
        perimeterBuildingFootprint: [
          {
            required: true,
            message: 'Please enter perimeter building footprint',
            trigger: 'blur',
          },
        ],
        averageStoryHeight: [
          {
            required: true,
            message: 'Please enter story height',
            trigger: 'blur',
          },
        ],
        totalSiteArea: [
          {
            required: true,
            message: 'Please enter total site area',
            trigger: 'blur',
          },
        ],
        numberOfBuilding: [
          {
            required: true,
            message: 'Please enter number of building',
            trigger: 'blur',
          },
        ],
      },
      rulesformTenants: {
        tenantApproachId: undefined,
      },
      loader: true,
      data: [],
      title: '',
      newTenants: null,
      selectedRowKeys: [],
      headStyle: {
        'font-weight': 'bold',
        background: '#333333 !important',
        color: '#ffffff !important',
        padding: '0 10px',
      },
      loadTenant: false,
      tenantLoader: true,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        suppressContextMenu: true,
        rowDragManaged: true,
        defaultColDef: {
          sortable: true,
          resizable: true,
          suppressMovable: true,
          singleClickEdit: true,
          menuTabs: ['filterMenuTab'],
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      tableParams: null,
      tenantHeight: {
        width: '100%',
        height: '140px',
      },
      exportClicked: false,
      uploadedFile: null,
      importClicked: false,
      importColDef: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Suite #',
          field: 'suite',
          width: 80,
        },
        {
          headerName: 'Tenant Name',
          field: 'tenantName',
          width: 120,
        },
        {
          headerName: 'Tenant Type',
          field: 'tenantType',
          width: 120,
        },
        {
          headerName: 'Tenant SF',
          field: 'tenantSF',
          width: 120,
        },
      ],
      loadImport: false,
      bankName: null,
      bankId: null,
      visible: false,
      disableApproach: false,
      cardHeight: '446px',
      apiURL: null,
      showBank: false,
      tenantBanks: this.dropdownData.tenantBank,
      message: undefined,
      tenantDetails: null,
      sidebarView: false,
      sortData: null,
    }
  },
  beforeMount() {
    this.loadingConfig()
  },
  watch: {
    collapsed() {
      this.sidebarView = this.collapsed
    },
  },
  created() {
    this.$socketHub.$on('message-received', this.recievedMessage)
  },
  mounted() {
    this.getBuildingGeneral()
    this.$root.$off('saveTenantData')
    this.$root.$off('deleteTenant')
    this.$root.$off('copyTenantBank')
    this.$root.$off('addInBank')
    this.$root.$off('cloneTenant')
    this.$root.$on('cloneTenant', this.cloneTenant)
    this.$root.$on('saveTenantData', this.updateTenant)
    this.$root.$on('deleteTenant', this.deleteTenant)
    this.$root.$on('copyTenantBank', this.updateTenantBank)
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$on('addInBank', this.saveAsBank)
    this.$root.$off('loadSidebar')
    this.$root.$on('loadSidebar', this.loadSidebar)
  },
  beforeDestroy() {
    this.$root.$off('saveTenantData')
    this.$root.$off('deleteTenant')
    this.$socketHub.$off('message-received')
    this.$root.$off('copyTenantBank')
    window.removeEventListener('resize', this.getWindowSize)
    this.$root.$off('addInBank')
    this.$root.$off('cloneTenant')
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        inputCellEditor: InputEditor,
        selectEditor: SelectEditorDynamic,
        inputNumberEditor: InputNumberEditor,
        customFilter: CustomFilter,
        numberRender: NumberRender,
        toolTipRenderer: ToolTipRenderer,
      }
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 36,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          hide: this.viewOnly,
          menuTabs: [],
        },
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          resizable: false,
          suppressSizeToFit: true,
          pinned: 'left',
          hide: this.viewOnly,
          menuTabs: [],
        },
        {
          headerName: 'Suite #',
          field: 'suite',
          width: 80,
          headerTooltip: 'Suite',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellEditor: 'inputCellEditor',
          filter: 'customFilter',
          editable: !this.viewOnly,
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'tenants',
            dataType: 'string',
          },
        },
        {
          headerName: 'Tenant Name',
          field: 'tenantName',
          headerTooltip: 'Tenant Name',
          cellEditor: 'inputCellEditor',
          editable: !this.viewOnly,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'tenants',
            dataType: 'string',
          },
        },
        {
          headerName: 'Tenant Type',
          field: 'tenantType',
          width: 200,
          headerTooltip: 'Tenant Type',
          cellEditor: 'selectEditor',
          editable: !this.viewOnly,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'tenantType',
            dataType: 'string',
            dropdownName: 'tenantType',
            dropdownData: this.dropdownData,
          },
          suppressSizeToFit: true,
        },
        {
          headerName: 'Tenant SF',
          field: 'tenantSF',
          width: 120,
          headerTooltip: 'Tenant SF',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellEditor: 'inputNumberEditor',
          editable: !this.viewOnly,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'tenants',
            dataType: 'int',
            placeholder: 'Tenant SF',
            precision: 0,
            min: 0,
            fixed: 0,
            max: 999999,
          },
          cellRenderer: 'numberRender',
          suppressSizeToFit: true,
        },
        {
          headerName: 'Tenant Bank',
          field: 'tenantBank',
          width: 200,
          headerTooltip: 'Tenant Bank',
          filter: 'customFilter',
          cellEditor: 'selectEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'tenantBank',
            dropdownName: 'tenantBank',
            dropdownData: this.dropdownData,
          },
          suppressSizeToFit: true,
          editable: params => {
            return this.formTenants.tenantApproachId === 1 && !this.viewOnly
          },
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          headerClass: 'header-center',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          cellRendererParams: {
            type: 'tenants',
            IsTemplate: true,
          },
          pinned: 'right',
          hide: this.viewOnly,
          menuTabs: [],
        },
      ]
    },

    getBuildingGeneral() {
      instance
        .get(
          templateAPIs.buildingGeneral.getBuildingGeneralDetails(
            this.$route.params.id,
          ),
        )
        .then(response => {
          this.formGeneral = formatKeys(
            _.get(response.data, 'result', null),
            this.formGeneral,
          )
          this.loader = false
          if (this.templateData.structureProfileId === 3) {
            this.getColumnSettings(this.gridOptions)
            this.getTenants(this.gridOptions)
          }
          Object.assign(this.templateData, {
            area_Total_Building: this.formGeneral.areaTotalBuilding,
            area_Building_Footprint: this.formGeneral.areaBuildingFootprint,
            number_Of_Stories: this.formGeneral.numberOfStories,
            perimeter_Building_Footprint: this.formGeneral
              .perimeterBuildingFootprint,
            average_Story_Height: this.formGeneral.averageStoryHeight,
            totalSiteArea: this.formGeneral.totalSiteArea,
            numberOfBuilding: this.formGeneral.numberOfBuilding,
          })
          this.cardHeight = calculateHeight('templateBuildingGeneral', true)
          this.sidebarView = this.collapsed
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    updateBuildingGeneral(fieldName, value, valueType) {
      this.$refs[fieldName].onFieldBlur()
      this.fieldName = fieldName
      const currentValue = !value ? '' : value
      const previousValue = !window.previousValue ? '' : window.previousValue
      let msg = null
      let request = {}
      if (previousValue.toString() !== currentValue.toString()) {
        let isValid = true
        switch (fieldName) {
          case 'softCosts':
            isValid = validateNumber(
              this.formGeneral.softCosts,
              fieldName,
              'Soft Costs (%)',
            )
            if (isValid) {
              this.formGeneral.softCosts = value
                ? formatValue(value, 2)
                : value
              request = {
                softCosts: value ? formatValue(value, 2) : null,
              }
            } else {
              this.formGeneral.softCosts = previousValue
            }
            break
          case 'areaTotalBuilding':
            isValid = validateNumber(
              this.formGeneral.areaTotalBuilding,
              fieldName,
              'Area (Total Building)',
            )
            if (isValid) {
              this.formGeneral.areaTotalBuilding = value
                ? formatValue(value, 0)
                : value
              this.formGeneral.areaBuildingFootprint = calculateAreaBuildingFootprint(
                value ? formatValue(value, 0) : value,
                this.formGeneral.numberOfStories,
              )
              this.formGeneral.perimeterBuildingFootprint = calculatePerimeter(
                this.formGeneral.numberOfBuilding || 1,
                this.formGeneral.areaBuildingFootprint || 0,
              )
              this.templateData.area_Total_Building = value
                ? formatValue(value, 0)
                : 0
              this.templateData.area_Building_Footprint = this.formGeneral.areaBuildingFootprint
              this.templateData.perimeter_Building_Footprint = this.formGeneral.perimeterBuildingFootprint
              request = {
                areaTotalBuilding: value ? formatValue(value, 0) : null,
                areaBuildingFootprint: this.formGeneral.areaBuildingFootprint,
                perimeterBuildingFootprint: this.formGeneral
                  .perimeterBuildingFootprint,
              }
              msg = 'Please wait while updating building general details'
              this.$root.$emit('popupUpdation', true, true, msg)
            } else {
              this.formGeneral.areaTotalBuilding = previousValue
            }
            break
          case 'numberOfStories':
            isValid = validateNumber(
              this.formGeneral.numberOfStories,
              fieldName,
              'Number of Stories',
            )
            if (isValid) {
              this.formGeneral.numberOfStories = value
                ? formatValue(value, 0)
                : value
              this.formGeneral.areaBuildingFootprint = calculateAreaBuildingFootprint(
                this.formGeneral.areaTotalBuilding,
                value ? formatValue(value, 0) : value,
              )
              this.formGeneral.perimeterBuildingFootprint = calculatePerimeter(
                this.formGeneral.numberOfBuilding || 1,
                this.formGeneral.areaBuildingFootprint || 0,
              )
              this.templateData.number_Of_Stories = value
                ? formatValue(value, 0)
                : 0
              this.templateData.area_Building_Footprint = this.formGeneral.areaBuildingFootprint
              this.templateData.perimeter_Building_Footprint = this.formGeneral.perimeterBuildingFootprint
              request = {
                numberOfStories: value ? formatValue(value, 0) : null,
                areaBuildingFootprint: this.formGeneral.areaBuildingFootprint,
                perimeterBuildingFootprint: this.formGeneral
                  .perimeterBuildingFootprint,
              }
              msg = 'Please wait while updating building general details'
              this.$root.$emit('popupUpdation', true, true, msg)
            } else {
              this.formGeneral.numberOfStories = previousValue
            }
            break
          case 'areaBuildingFootprint':
            isValid = validateNumber(
              this.formGeneral.areaBuildingFootprint,
              fieldName,
              'Area (Building Footprint)',
            )
            if (isValid) {
              this.formGeneral.areaBuildingFootprint = value
                ? formatValue(value, 0)
                : value
              this.formGeneral.perimeterBuildingFootprint = calculatePerimeter(
                this.formGeneral.numberOfBuilding || 1,
                value ? formatValue(value, 0) : 0,
              )
              this.templateData.area_Building_Footprint = value
                ? formatValue(value, 0)
                : 0
              this.templateData.perimeter_Building_Footprint = this.formGeneral.perimeterBuildingFootprint
              request = {
                areaBuildingFootprint: value ? formatValue(value, 0) : null,
                perimeterBuildingFootprint: this.formGeneral
                  .perimeterBuildingFootprint,
              }
              msg = 'Please wait while updating building general details'
              this.$root.$emit('popupUpdation', true, true, msg)
            } else {
              this.formGeneral.areaBuildingFootprint = previousValue
            }
            break
          case 'perimeterBuildingFootprint':
            isValid = validateNumber(
              this.formGeneral.perimeterBuildingFootprint,
              fieldName,
              'Perimeter (Building Footprint)',
            )
            if (isValid) {
              this.formGeneral.perimeterBuildingFootprint = value
                ? formatValue(value, 0)
                : value
              this.templateData.perimeter_Building_Footprint = value
                ? formatValue(value, 0)
                : 0
              request = {
                perimeterBuildingFootprint: value ? formatValue(value, 0) : null,
              }
              msg = 'Please wait while updating building general details'
              this.$root.$emit('popupUpdation', true, true, msg)
            } else {
              this.formGeneral.perimeterBuildingFootprint = previousValue
            }
            break
          case 'averageStoryHeight':
            isValid = validateNumber(
              this.formGeneral.averageStoryHeight,
              fieldName,
              'Average Story Height',
            )
            if (isValid) {
              this.formGeneral.averageStoryHeight = value
                ? formatValue(value, 0)
                : value
              this.templateData.average_Story_Height = value
                ? formatValue(value, 0)
                : 0
              request = {
                averageStoryHeight: value ? formatValue(value, 0) : null,
              }
              msg = 'Please wait while updating building general details'
              this.$root.$emit('popupUpdation', true, true, msg)
            } else {
              this.formGeneral.averageStoryHeight = previousValue
            }
            break
          case 'constructionQualityFactorId':
            const constructionfactor = this.dropdownData.construction_quality_factor.find(
              i => i.id === value,
            )
            request = {
              constructionQualityFactorId: value,
              ConstructionQualityFactorValue: constructionfactor
                ? constructionfactor.value
                : null,
            }
            break
          case 'conditionFactorId':
            const factor = this.dropdownData.condition_factor.find(
              i => i.id === value,
            )
            request = {
              conditionFactorId: value,
              ConditionFactorValue: factor ? factor.value : null,
            }
            break
          case 'totalSiteArea':
            isValid = validateNumber(
              this.formGeneral.totalSiteArea,
              fieldName,
              'Total Site Area',
            )
            if (isValid) {
              this.formGeneral.totalSiteArea = value
                ? formatValue(value, 0)
                : value
              this.templateData.totalSiteArea = value
                ? formatValue(value, 0)
                : 0
              request = {
                totalSiteArea: value ? formatValue(value, 0) : null,
              }
              msg = 'Please wait while updating building general details'
              this.$root.$emit('popupUpdation', true, true, msg)
            } else {
              this.formGeneral.totalSiteArea = previousValue
            }
            break
          case 'numberOfBuilding':
            isValid = validateNumber(
              this.formGeneral.numberOfBuilding,
              fieldName,
              'Number of Building',
            )
            if (isValid) {
              this.formGeneral.numberOfBuilding =
                value === '0' ? 1 : value ? formatValue(value, 0) : 1
              this.formGeneral.perimeterBuildingFootprint = calculatePerimeter(
                value === '0' ? 1 : value ? formatValue(value, 0) : 1,
                this.formGeneral.areaBuildingFootprint || 0,
              )
              this.templateData.numberOfBuilding =
                value === '0' ? 1 : value ? formatValue(value, 0) : 1
              this.templateData.perimeter_Building_Footprint = this.formGeneral.perimeterBuildingFootprint
              request = {
                numberOfBuilding:
                  value === '0' ? 1 : value ? formatValue(value, 0) : 1,
                perimeterBuildingFootprint: this.formGeneral
                  .perimeterBuildingFootprint,
              }
              msg = 'Please wait while updating building general details'
              this.$root.$emit('popupUpdation', true, true, msg)
            } else {
              this.formGeneral.numberOfBuilding = previousValue
            }
            break
          default:
            break
        }
        if (isValid) {
          this.fieldLoader = true
          instance
            .patch(
              templateAPIs.buildingGeneral.updateBuildinggeneral(
                this.$route.params.id,
                this.formGeneral.id,
              ),
              request,
            )
            .then(response => {
              this.fieldName = undefined
              this.fieldLoader = false
            })
            .catch(err => {
              errorService(err)
              this.fieldLoader = false
              this.$root.$emit('popupUpdation', false, true, null)
            })
        }
      }
    },

    getTenants(params) {
      if (this.formGeneral.id) {
        const url = templateAPIs.buildingGeneral.tenant.getTenantDetails(
          this.$route.params.id,
          this.formGeneral.id,
        )
        this.tenantLoader = true
        instance
          .get(url)
          .then(response => {
            this.formTenants.tenants = []
            this.formTenants = _.get(response.data, 'result', null)
            this.showBank = this.formTenants.tenantApproachId === 2
            const tenant = _.get(response.data, 'result.tenants', []).find(
              i => i.type === 2,
            )
            if (tenant) {
              this.formTenants.tenantId = tenant.id
              this.formTenants.tenantBank = tenant.tenantBank
              this.formTenants.tenantBankId = tenant.tenantBankId
              this.formTenants.tenantType = tenant.tenantType
              this.formTenants.tenantTypeId = tenant.tenantTypeId
              this.formTenants.tenantSF = tenant.tenantSF
              if (this.formTenants.tenantTypeId) {
                this.tenantBanks = this.dropdownData.tenantBank.filter(
                  i => i.tenantTypeId === this.formTenants.tenantTypeId,
                )
              }
            }
            this.formTenants.tenants = _.get(
              this.formTenants,
              'tenants',
              [],
            ).filter(i => i.type === 1)
            if (this.tableId) {
              this.tenantHeight.height = '200px'
            } else {
              const element = document.querySelector('#' + 'templateBuildingGeneral')
              if (element) {
                this.tenantHeight.height =
                  Math.round(element.getBoundingClientRect().height) -
                  260 +
                  'px'
              }
            }
            this.formTenants.tenants.forEach(element => {
              element.tenantApproachId = this.formTenants.tenantApproachId
            })
            this.gridOptions.api.redrawRows()
            this.gridOptions.columnApi.applyColumnState({
              state: [
                {
                  colId: 'tenantBank',
                  hide: this.formTenants.tenantApproachId === 2,
                },
                {
                  colId: 'tenantType',
                  hide: this.formTenants.tenantApproachId === 2,
                },
              ],
            })
            if (this.sortData) {
              this.formTenants.tenants = _.orderBy(
                this.formTenants.tenants,
                [this.sortData.colId],
                [this.sortData.sort],
              )
            }
            this.tenantLoader = false
          })
          .catch(error => {
            this.tenantLoader = false
            errorService(error)
          })
      }
    },

    addTenant() {
      this.tableLoader = true
      const url = templateAPIs.buildingGeneral.tenant.addTenant(
        this.$route.params.id,
        this.formGeneral.id,
      )
      instance
        .post(url, {
          tenantApproachId: this.formTenants.tenantApproachId,
          tenantCount: this.newTenants ? this.newTenants : 1,
        })
        .then(response => {
          this.getTenants()
          this.newTenants = null
          this.tableLoader = false
        })
        .catch(err => {
          this.tableLoader = false
          errorService(err)
        })
    },

    deleteAllTenants() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected tenants ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              tenants
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() {},
        class: 'test',
      })
    },

    deleteTenant(record) {
      var that = this
      this.$confirm({
        title: `Are you sure want to delete '${record.suite}' ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to this tenant.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
        onCancel() {},
      })
    },

    confirmDelete(record) {
      this.loading = true
      this.tenantLoader = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(
          `${templateAPIs.buildingGeneral.tenant.deleteTenant(
            this.$route.params.id,
            this.formGeneral.id,
          )}`,
          {
            data: req,
          },
        )
        .then(response => {
          this.loading = true
          showNotification(
            'success',
            'Delete Tenant',
            _.get(response.data, 'message', null),
          )
          this.getTenants()
          this.selectedRowKeys = record
            ? this.selectedRowKeys.remove(record.id)
            : []
        })
        .catch(err => {
          this.loading = false
          this.tenantLoader = false
          errorService(err)
        })
    },

    updateTenantApproach(FieldName, value, valueType) {
      this.fieldName = FieldName
      const currentValue = !value ? '' : value
      const previousValue = !window.previousValue ? '' : window.previousValue
      if (previousValue.toString() !== currentValue.toString()) {
        this.fieldLoader = true
        instance
          .patch(
            templateAPIs.buildingGeneral.tenant.updateTenantApproach(
              this.$route.params.id,
              this.formGeneral.id,
            ),
            {
              tenantApproachId: value,
            },
          )
          .then(response => {
            this.fieldLoader = false
          })
          .catch(err => {
            errorService(err)
            this.fieldLoader = false
            this.$root.$emit('popupUpdation', false, true, null)
          })
      }
    },

    changeWarning(FieldName, value, valueType) {
      var that = this
      if (window.previousValue) {
        this.$confirm({
          title: `Are you sure you want to change approach ?`,
          content: h => (
            <div style="color:red;">
              <p>
                This action will effect calculation method and view part of
                tenant.
              </p>
              <p>Please confirm</p>
            </div>
          ),
          onOk() {
            that.updateTenantApproach(FieldName, value, valueType)
            const previous = that.dropdownData['tenant_approach'].find(
              i => i.id === window.previousValue,
            ).option
            const current = that.dropdownData['tenant_approach'].find(
              i => i.id === value,
            ).option
            const msg = `Please wait while the tenant approach is changed from ${previous} to ${current}...`
            that.message = msg
            that.$root.$emit('popupUpdation', true, true, msg)
          },
          onCancel() {
            that.formTenants.tenantApproachId = window.previousValue
          },
        })
      } else {
        this.updateTenantApproach(FieldName, value, valueType)
        const msg = `Please wait while the tenant approach is selected...`
        this.message = msg
        this.$root.$emit('popupUpdation', true, true, msg)
      }
    },

    updateTenant(fieldName, value, headerName, record, isCheck) {
      const currentValue = !value ? '' : value
      const previousValue = window.previousValue ? window.previousValue : ''
      let isValid = true
      if (previousValue.toString() !== currentValue.toString()) {
        let request = {}
        this.tenantDetails = { ...record }
        switch (fieldName) {
          case 'tenantType':
            const tenantType = this.dropdownData.tenantType.find(
              i => i.tenantType === value,
            )
            request = {
              [fieldName]: !value || value === 'none' ? null : value,
              tenantTypeId: tenantType ? tenantType.id : null,
            }
            break
          case 'tenantSF':
            isValid = validateNumber(value, fieldName, 'Tenant SF')
            if (isValid) {
              request = {
                [fieldName]: value || null,
              }
            }
            break
          case 'tenantBank':
            request = {
              tenantBankId: null,
              tenantBank: null,
            }
            break
          default:
            request = {
              [fieldName]: value,
            }
            break
        }
        if (isValid) {
          this.updateTenantData(record.id, request, headerName, null, null, value, isCheck)
        } else {
          const index = this.formTenants.tenants.findIndex(
            i => i.id === record.id,
          )
          setTimeout(() => {
            this.resetRowData(index)
          }, 100)
        }
      } else {
        if (fieldName === 'tenantSF') {
          isValid = validateNumber(value, fieldName, 'Tenant SF')
          if (!isValid) {
            const index = this.formTenants.tenants.findIndex(
              i => i.id === record.id,
            )
            setTimeout(() => {
              this.resetRowData(index)
            }, 100)
          }
        }
      }
    },

    updateTenantBank(value, bankId, data, index, isCheck) {
      this.tenantDetails = { ...data }
      var that = this
      const url = templateAPIs.buildingGeneral.tenant.applyTenantBank(
        this.$route.params.id,
        this.formGeneral.id,
        data.id,
        bankId,
      )
      if (data.tenantBankId) {
        this.$confirm({
          title: `Are you sure you want to change tenant bank ?`,
          content: h => (
            <div style="color:red;">
              <p>
                This action will override the takeoff and grouping with the new
                tenant bank takeoff and grouping.
              </p>
              <p>Please confirm</p>
            </div>
          ),
          onOk() {
            if (value === 'none') {
              that.updateTenant('tenantBank', value, 'Tenant Bank', data, isCheck)
            } else {
              that.tenantDetails = { ...data }
              const msg = 'Please wait while apply tenant bank!'
              that.$root.$emit('popupUpdation', true, true, msg)
              that.updateTenantData(data.id, bankId, 'Tenant Bank', url, 'put', null, isCheck)
            }
          },
          onCancel() {
            if (that.formTenants.tenantApproachId === 1) {
              const tenants = [...that.formTenants.tenants]
              tenants[index]['tenantBank'] = data.tenantBank
              tenants[index]['tenantBankId'] = data.tenantBankId
              that.formTenants.tenants = [...tenants]
              setTimeout(() => {
                that.resetRowData(index)
              }, 1000)
            } else {
              that.formTenants.tenantBank = data.tenantBank
              that.formTenants.tenantBankId = data.tenantBankId
            }
          },
        })
      } else {
        if (value === 'none') {
          this.updateTenant('tenantBank', value, 'Tenant Bank', data, isCheck)
        } else {
          const msg = 'Please wait while apply tenant bank!'
          this.$root.$emit('popupUpdation', true, true, msg)
          this.updateTenantData(data.id, bankId, 'Tenant Bank', url, 'put', null, isCheck)
        }
      }
    },

    updateTenantData(id, request, headerName, apiURL, apiMethod, value, isCheck) {
      var bankId = null
      if (headerName === 'Tenant Bank' && value !== 'none') {
        bankId = request
        request = null
      }
      this.tenantLoader = true
      const method = apiMethod || 'patch'
      const url =
        apiURL ||
        templateAPIs.buildingGeneral.tenant.updateTenant(
          this.$route.params.id,
          this.formGeneral.id,
          id,
        )
      let index = this.formTenants.tenants.findIndex(i => i.id === id)
      instance[method](url, request)
        .then(response => {
          if (this.sortData) {
            this.formTenants.tenants = _.orderBy(
              this.formTenants.tenants,
              [this.sortData.colId],
              [this.sortData.sort],
            )
          }
          index = this.formTenants.tenants.findIndex(i => i.id === id)
          const data = this.formTenants.tenants
          showNotification(
            'success',
            headerName,
            _.get(
              response.data,
              'message',
              headerName + ' updated successfully!',
            ),
          )
          this.tenantLoader = false
          let key
          switch (headerName) {
            case 'Suite':
              key = 'suite'
              break
            case 'Tenant Name':
              key = 'tenantName'
              break
            case 'Tenant Type':
              key = 'tenantType'
              data[index] = _.get(response.data, 'result', null)
              this.formTenants.tenants = data
              const itemsToUpdate = updateGridRecord(
                this.gridOptions,
                this.formTenants.tenants[index],
                data[index],
              )
              this.gridOptions.api.applyTransaction({
                update: itemsToUpdate,
              })
              this.gridOptions.api.redrawRows()
              break
            case 'Tenant SF':
              if (!isCheck) {
                this.formTenants.tenantSF = data.reduce((total, item) => {
                  return total + (item.tenantSF || 0)
                }, 0)
              }
              key = 'tenantSF'
              break
            case 'Tenant Bank':
              key = 'tenantBank'
              this.showBank = this.formTenants.tenantApproachId === 2
              const tenant = this.dropdownData.tenantBank.find(
                t => t.id === bankId,
              )
              const itemsToUpdateTenant = []
              this.gridOptions.api.forEachNodeAfterFilterAndSort(function(
                rowNode,
              ) {
                if (rowNode.data.id === id) {
                  rowNode.data.tenantSF = rowNode.data.tenantSF
                    ? rowNode.data.tenantSF
                    : tenant.tenantSF
                  rowNode.data.tenantTypeId = rowNode.data.tenantTypeId
                    ? rowNode.data.tenantTypeId
                    : tenant.tenantTypeId
                  rowNode.data.tenantType = rowNode.data.tenantType
                    ? rowNode.data.tenantType
                    : tenant.tenantType
                  rowNode.data.tenantBankId = tenant
                    ? tenant.id
                    : rowNode.data.tenantBankId
                  rowNode.data.tenantBank = tenant
                    ? tenant.tenantName
                    : rowNode.data.tenantBank
                  const data = rowNode.data
                  itemsToUpdateTenant.push(data)
                }
              })
              this.gridOptions.api.applyTransaction({
                update: itemsToUpdateTenant,
              })
              this.gridOptions.api.redrawRows()
              break
            default:
              break
          }
          if (!isCheck) {
            this.setFocusedCell(key, index)
          }
        })
        .catch(err => {
          errorService(err)
          this.tenantLoader = false
          this.resetRowData(index)
        })
    },

    updateBulkTenant(selectedRowData) {
      this.loading = true
      const url = templateAPIs.buildingGeneral.tenant.bulkUpdateTenant(
        this.$route.params.id,
        this.formGeneral.id,
      )
      instance
        .put(url, selectedRowData)
        .then(response => {
          this.loading = false
          this.importClicked = false
          this.tenantLoader = true
          this.loadImport = false
          showNotification('success', 'Import', response.data.message)
          this.getTenants(this.tableParams)
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    applyTenantBank(value) {
      const tenant = this.dropdownData.tenantBank.find(
        i => i.tenantName === value,
      )
      this.updateTenantBank(
        value || 'none',
        tenant ? tenant.id : null,
        { id: this.formTenants.tenantId },
        undefined,
        true,
      )
      this.formTenants.tenantBankId = tenant ? tenant.id : null
    },

    onChangeTenantType(value) {
      const tenantType = this.dropdownData.tenantType.find(
        i => i.tenantType === value,
      )
      if (tenantType) {
        this.tenantBanks = this.dropdownData.tenantBank.filter(
          i => i.tenantTypeId === tenantType.id,
        )
      } else {
        this.tenantBanks = []
        this.tenantBanks = this.dropdownData.tenantBank
      }
      this.updateTenant(
        'tenantType',
        value || 'none',
        'Tenant Type',
        { id: this.formTenants.tenantId },
        true,
      )
    },

    updateTenantSF() {
      this.updateTenant(
        'tenantSF',
        this.formTenants.tenantSF,
        'Tenant SF',
        { id: this.formTenants.tenantId },
        true,
      )
    },

    addValueToDropdown() {
      if (this.formGeneral.constructionQualityFactorId) {
        const factor = this.dropdownData['construction_quality_factor'].find(
          i => i.id === this.formGeneral.constructionQualityFactorId,
        )
        if (!factor) {
          this.dropdownData['construction_quality_factor'].push({
            option: this.formGeneral.constructionQualityFactor,
            value: this.formGeneral.constructionQualityFactorValue,
          })
        }
      }
      if (this.formGeneral.conditionFactorId) {
        const factor = this.dropdownData['condition_factor'].find(
          i => i.id === this.formGeneral.conditionFactorId,
        )
        if (!factor) {
          this.dropdownData['condition_factor'].push({
            option: this.formGeneral.conditionFactor,
            value: this.formGeneral.conditionFactorValue,
          })
        }
      }
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    downloadTemplate() {
      this.exportClicked = true
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid = checkFiles(file.type)
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.getTenants(this.gridOptions)
      }
    },

    clickedCancel() {
      this.exportClicked = false
    },

    updateTable() {
      this.importClicked = false
      this.tenantLoader = true
      this.getTenants(this.tableParams)
    },

    loadSidebar(message) {
      this.recievedMessage(message)
    },

    getWindowSize() {
      if (this.tableId) {
        this.tenantHeight.height = '200px'
      } else {
        const element = document.querySelector('#' + 'projectdetails')
        if (element) {
          this.tenantHeight.height =
            Math.round(element.getBoundingClientRect().height) - 126 + 'px'
        }
      }
      this.cardHeight = calculateHeight('templateBuildingGeneral', true)
    },

    saveAsBank(data) {
      this.bankName = data.tenantName
      this.bankId = data.id
      this.visible = true
      this.apiURL = templateAPIs.buildingGeneral.tenant.saveAsTenantBank(
        this.$route.params.id,
        this.formGeneral.id,
        data.id,
      )
    },

    closeBank(flag) {
      this.visible = flag
    },

    reorder(request) {
      const url = templateAPIs.buildingGeneral.tenant.reorderTenant(
        this.$route.params.id,
        this.formGeneral.id,
      )
      instance
        .patch(url, request)
        .then(response => {
          this.tenantLoader = false
          this.selectedRowKeys = []
          this.gridOptions.api.deselectAll()
        })
        .catch(err => {
          this.tenantLoader = false
          errorService(err)
        })
    },

    onModelUpdated() {
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length === 0
      ) {
        this.gridOptions.api.showNoRowsOverlay()
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length > 0
      ) {
        this.gridOptions.api.hideOverlay()
      }
    },

    isNumber(evt) {
      const splitNumber = this.newTenants
      if (splitNumber && splitNumber.length > 3) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    resetRowData(index) {
      const newData = [...this.formTenants.tenants]
      newData[index] = this.tenantDetails
      this.formTenants.tenants = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.tenantDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.tenantDetails = null
    },

    cloneTenant(data) {
      this.tableLoader = true
      const req =
        this.selectedRowKeys.length === 0
          ? [data.data.id]
          : this.selectedRowKeys
      const url = templateAPIs.buildingGeneral.tenant.cloneTenant(
        this.$route.params.id,
        this.formGeneral.id,
      )
      instance
        .post(url, req)
        .then(response => {
          // this.getTenants()
          // this.newTenants = null
          // this.tableLoader = false
        })
        .catch(err => {
          this.tableLoader = false
          errorService(err)
        })
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSetting()
      }
    },

    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      if (sortData.length > 0) {
        this.formTenants.tenants = _.orderBy(
          this.formTenants.tenants,
          [sortData[0]['colId']],
          [sortData[0]['sort']],
        )
        this.sortData = sortData[0]
      } else {
        this.formTenants.tenants = _.orderBy(
          this.formTenants.tenants,
          ['tenantName'],
          ['asc'],
        )
        this.sortData = {
          colId: 'tenantName',
          sort: 'asc',
        }
      }
      this.updateColumnSetting()
    },

    onRowDragEnd(e) {
      this.tenantLoader = true
      const request = []
      this.gridOptions.api.forEachNodeAfterFilterAndSort(function(rowNode, index) {
        request.push({
          id: rowNode.data.id,
          sequence: index + 1,
        })
      })
      this.reorder(request)
    },

    onRowDragLeave(e) {
      this.onRowDragEnd(e)
    },

    getColumnSettings(params) {
      if (params && params !== 1) {
        params.api.setColumnDefs(this.columnDefs)
      }
      const columnDetails = this.columnSettings.find(
        i => i.screenId === 1 && i.tableName === tableName.template.tenant,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        const column = {
          colId: 'display',
          width: 36,
          hide: false,
          pinned: 'left',
          sort: null,
          sortIndex: null,
          aggFunc: null,
          rowGroup: false,
          rowGroupIndex: null,
          pivot: false,
          pivotIndex: null,
          flex: null,
        }
        const isPresent = tableState.some(i => i.colId === 'display')
        if (!isPresent) {
          tableState.unshift(column)
        }
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
          this.defaultSortedBy = 'tenantName'
          this.defaultSortOrder = true
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: 1,
        tableName: tableName.template.tenant,
        columnDetails: JSON.stringify(tableState),
      }
      this.$emit('updateColumnSettings', request)
    },

    setFocusedCell(key, index) {
      let newKey
      switch (key) {
        case 'suite':
          newKey = 'tenantName'
          break
        case 'tenantName':
          if (this.templateData.analysisTypeId === 2) {
            newKey = 'tenantSF'
          } else {
            newKey = 'tenantType'
          }
          break
        case 'tenantType':
          newKey = 'tenantSF'
          break
        case 'tenantSF':
          if (this.templateData.analysisTypeId === 2) {
            if (index < this.formTenants.tenants.length - 1) {
              newKey = 'suite'
              index = index + 1
            }
          } else {
            newKey = 'tenantBank'
          }
          break
        case 'tenantBank':
          if (index < this.formTenants.tenants.length - 1) {
            index = index + 1
            newKey = 'suite'
          }
          break

        default:
          break
      }
      if (newKey) {
        this.gridOptions.api.setFocusedCell(index, newKey)
        this.gridOptions.api.startEditingCell({
          rowIndex: index,
          colKey: newKey,
        })
      }
    },

    recievedMessage(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.CloneTenant) {
        this.getTenants()
        this.newTenants = null
        this.tableLoader = false
      } else if (data.EventType === socketEvents.templateSideBarUpdated) {
        if (this.fieldName === 'tenantApproachId') {
          this.$root.$emit('templateSideBarUpdated', message, true)
          this.$root.$emit('popupUpdation', true, true, this.message)
        } else {
          this.$root.$emit('templateSideBarUpdated', message)
        }
      } else if (data.EventType === socketEvents.tenantApproachUpdated) {
        this.tenantLoader = true
        if (this.templateData.structureProfileId === 3) {
          this.getTenants(this.tableParams)
        }
        this.loadingTenant = 2
        this.fieldName = undefined
        this.message = undefined
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.projectTenantBankAdded) {
        this.$root.$emit('popupUpdation', false, true, null)
        this.tenantLoader = false
      } else if (data.EventType === socketEvents.fileImported) {
        this.$root.$emit('message-received', message)
      } else if (data.EventType === socketEvents.fileExported) {
        this.$root.$emit('message-received', message)
      } else if (data.EventType === socketEvents.error) {
        this.loadingTenant = 2
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification('error', 'Socket', data.Message)
      }
    },
  },
}
